<button
	[ngClass]="{
		'disabled': disabled,
		'selected': selected,
		'plp-color-swatch-selected': colorSwatchHoverDimension,
		'pdp-color-swatch-selected': !colorSwatchHoverDimension,
        'filter-color-swatch': filterColorSwatchHoverDimension,
        'personalization-swatch': isPersonalization
	}"
    [tabindex]="tabIndex"
    [attr.aria-label]="swatchAriaLabel"
    [ngStyle]="{ 'border-radius': radius }"
    (click)="attributeValueClicked($event.currentTarget)"
>
    <img
        *ngIf="imageSrc"
        [loading]="isLazy() ? 'lazy': 'eager'"
        [src]="imageSrc"
        [ngClass]="{'selected': selected}"
        [ngStyle]="{
            'height': height,
            'width': width,
            'border-radius': radius
        }"
        [alt]="altText"
        (error)="emitImageError($event)"
    />
    <div
        *ngIf="color && !imageSrc"
        class="css-color"
        [ngClass]="{'selected': selected}"
        [ngStyle]="{
            'background-color': color,
            'height': height,
            'width': width,
            'border-radius': radius
        }">
    </div>
</button>
